<div class="container-404">
  <div class="container">
    <div class="row">
      <div class="col-md-7 hidden-sm hidden-xs">
        <img src="images_ext/404.png" class="img-responsive" style="margin:0 auto;">
      </div>
      <div class="col-md-5" style="margin-top: 10em;">
        <h1 style="font-weight: 700;font-size: 7em;">Oops!</h1>
        <h3>We're sorry, The school is suspended</h3>
        <p style="margin: 2em 0em;">Please contact School amin for more info</p>
        <p>Some helpful links:</p>
        <ul>
          <li><a [routerLink]="['/login']">Login</a></li>
        </ul>
        <div style="border-top: 1px solid #e4e4e4;padding: 5px 0px;">
          <p style="font-size: 11px;">© 2018 {{ brand.name }}. All right reserved.</p>
        </div>
      </div>

    </div>
  </div>
</div>
